import { render, staticRenderFns } from "./ChallengeCard.vue?vue&type=template&id=35947dfb&scoped=true"
import script from "./ChallengeCard.vue?vue&type=script&lang=ts"
export * from "./ChallengeCard.vue?vue&type=script&lang=ts"
import style0 from "./ChallengeCard.vue?vue&type=style&index=0&id=35947dfb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35947dfb",
  null
  
)

export default component.exports